import type { IconData } from '@stacksjs/iconify-core'

export const fillAndSign: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M37.202 16.684c1.697-1.698 2.193-4.251.786-6.196A29 29 0 0 0 35 7a29 29 0 0 0-3.488-2.988c-1.945-1.407-4.498-.911-6.196.786L4.22 25.896c-.592.591-.982 1.352-1.055 2.185c-.14 1.588-.29 4.63.011 8.946a1.94 1.94 0 0 0 1.798 1.798c4.317.302 7.358.152 8.946.011c.833-.073 1.594-.463 2.185-1.055z\"/><path d=\"M32.999 19.885s-.624-2.778-4.366-6.52C24.891 9.625 22.113 9 22.113 9m-7.114 28.885s-.624-2.778-4.366-6.52C6.891 27.625 4.113 27 4.113 27M3 45h24a12 12 0 0 0 7.2-2.4l.8-.6m0 0l2.4-1.8a4 4 0 1 0-4.8 0zm0 0l2.4 1.8A6 6 0 0 0 41 45h5\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default fillAndSign
